import cn from 'classnames';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Editor from '../../Editor';
import { extConfig } from './config';
import { Props } from './types';
import { useEditorContext } from '../../Context';

import presetViewerStyles from '../../../Viewer/presets/Status/Status.scss';
import s from './Status.scss';

const StatusEditor: React.FC<React.PropsWithChildren<Props>> = ({
  isShortStatus = false,
  children,
  ...props
}) => {
  const { t } = useTranslation('editor');
  const editor = useEditorContext();

  const focusEditor = useCallback(
    e => {
      if (
        e.target &&
        e.target.parentElement.getAttribute('data-wrapper') &&
        !editor?.isFocused &&
        editor?.isEmpty
      ) {
        editor?.commands.focus('end');
      }
    },
    [editor?.commands, editor?.isEmpty, editor?.isFocused]
  );

  return (
    <div data-wrapper="1" onClick={focusEditor} className={s['focus']}>
      <Editor
        {...props}
        withinModal
        presetId="status"
        className={cn(
          s['root'],
          presetViewerStyles['root'],
          isShortStatus && s['short-status']
        )}
        extensionConfig={extConfig}
        placeholder={t('preset.status.placeholder')}
      >
        {children}
      </Editor>
    </div>
  );
};
StatusEditor.displayName = 'StatusEditor';

export default StatusEditor;
